// we don't need to prepend anything if we're on these envs
const familySearchEnvs = ['integration.familysearch.org', 'beta.familysearch.org', 'www.familysearch.org']

/**
 * Returns true if the current domain is not one of the main FamilySearch environments
 * (integration.familysearch.org, beta.familysearch.org, www.familysearch.org). This includes
 * subdomains of familysearch.org (not listed in familySearchEnvs) and non-FamilySearch domains.
 * @function
 * @returns {boolean} true if links need prepending, false otherwise
 */
const needsBaseUrlPrefix = () => {
  try {
    const { hostname } = new URL(window.location.href)
    return !familySearchEnvs.includes(hostname)
  } catch {
    // If there's an error parsing the URL, assume links need prepending
    return true
  }
}

export { needsBaseUrlPrefix }
